<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length > 1 ? "UPDATE" : "ADD NEW" }}
        ADDRESS
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!--COUNTRY-->
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-select
              autocomplete
              v-model="dataIdCountry"
              label="Country"
              class="mt-0 w-full"
              name="country"
            >
              <vs-select-item
                :key="item.country_code"
                :value="item.country_code"
                :text="item.name_en"
                v-for="item in data_options_countries"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-3/4">
            <vs-input
              label="Place [AND/OR] Postal Code"
              v-model="dataSearchPlaceName"
              class="mt-0 w-full"
            />
          </div>
          <div class="vx-col w-1/4">
            <feather-icon
              icon="SearchIcon"
              svgClasses="h-0 w-0 mr-0 hover:text-primary cursor-pointer"
              class="mt-8 w-full"
              @click="submitSearch"
            />
          </div>
          <div class="vx-col w-full">
            <vs-select
              v-model="dataIdPlace"
              @change="getDataFromPlaceId"
              label="Places"
              class="mt-0 w-full"
              name="places"
            >
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.place"
                v-for="item in data_options_places"
              />
            </vs-select>
          </div>
        </div>

        <br />
        <hr class="mt-5 w-full" />
        <!-- Place Selection From Postal Coe -->
        <!--<vs-select v-model="dataCountry" @change="getOptionsPlaces" label="Country" class="mt-5 w-full" name="country">
          <vs-select-item :dir='ltr' :key="item.country_code" :value="item.country_code" :text="item.name_en" v-for="item in data_options_countries" />
        </vs-select>-->
        <!-- PLACE
        <vs-select v-model="dataPlaces" label="Place" class="mt-5 w-full" name="place">
          <vs-select-item :dir='ltr' :key="item.id" :value="item.id" :text="item.place_name" v-for="item in data_options_places" />
        </vs-select>-->

        <!-- LASTNAME -->
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-input
              label="Country"
              v-model="dataCountry"
              class="mt-8 w-full"
              name="country"
              disabled
            />
          </div>
          <div class="vx-col w-full">
            <vs-input
              label="Region"
              v-model="dataRegion"
              class="mt-4 w-full"
              name="region"
              disabled
            />
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              label="Postal"
              v-model="dataPostalCode"
              class="mt-4 w-full"
              name="postal"
              disabled
            />
          </div>
          <div class="vx-col w-2/3">
            <vs-input
              label="Place"
              v-model="dataPlace"
              v-validate="'required'"
              class="mt-4 w-full"
              name="place"
              disabled
            />
            <span class="text-danger text-sm" v-show="errors.has('place')">{{
              errors.first("place")
            }}</span>
          </div>
          <div class="vx-col w-3/4">
            <vs-input
              label="Street"
              v-model="dataStreet"
              class="mt-4 w-full"
              name="street"
            />
            <span class="text-danger text-sm" v-show="errors.has('street')">{{
              errors.first("street")
            }}</span>
          </div>
          <div class="vx-col w-1/4">
            <vs-input
              label="Num."
              v-model="dataNumber"
              class="mt-4 w-full"
              name="number"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <div class="vx-col w-full">
            <vs-select
              v-model="dataAddressCategory"
              label="Address Type *"
              class="mt-4 w-full"
              name="addresscategory"
            >
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.name_en"
                v-for="item in data_options_address_category"
              />
            </vs-select>
          </div>

          <div class="vx-col w-full mt-4" v-if="dataAddressCategory == 3 || dataAddressCategory == 1">
            <!-- DIAMETER -->
            <span class="mt-4" style="font-size:12px" >Default Delivery Address?</span>
            <vs-switch color="primary" color-off="danger" v-model="dataIsDefault">
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
          </div>

        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import modulePersonList from "@/store/people/modulePersonList.js";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  data() {
    return {
      data_options_address_category: [],
      data_options_countries: [],
      data_options_places: [],
      dataId: null,
      dataIdCountry: "",
      dataSearchPlaceName: "",
      dataIdPerson: "",
      dataIdPlace: "",
      dataPlace: "",
      dataAddressCategory: "",
      dataStreet: "",
      dataNumber: "",
      dataIsDefault: "",
      dataRegion: "",
      dataCountry: "",
      dataPostalCode: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 2) {
        this.initValues();
        this.$validator.reset();
        this.dataIdPerson = this.data.idperson;

        //new and already exist is auto delivery
        if (this.data.nbofaddress > 0) {
          this.dataAddressCategory = 3;
        }
        //this.data.nbofaddress
      } else {
        if (this.data.place.province)
          var region = this.data.place.region + "/" + this.data.place.province;
        else var region = this.data.place.region;
        this.dataIdPlace = this.data.place.id;
        this.dataAddressCategory = this.data.addresscategory.id;
        const {
          id,
          street,
          number,
          country,
          place,
          postal_code,
          province,
          idperson,
        } = JSON.parse(JSON.stringify(this.data));
        (this.dataId = id),
          (this.dataStreet = street),
          (this.dataNumber = number),
          (this.dataCountry = place.country.name_en),
          (this.dataRegion = region),
          (this.dataPlace = place.place_name),
          (this.dataPostalCode = place.postal_code),
          (this.dataSearchPlaceName = ""),
          (this.dataIdPerson = idperson),
          (this.dataIsDefault = isdefault),
          this.initValues();
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        /*this.dataStreet && this.dataNumber &&*/ this.dataPlace &&
        this.dataAddressCategory
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    async getAddressCategory() {
      axios.get("/addresscategory/data").then((response) => {
        this.data_options_address_category = [...response.data];
      });
    },
    getDataFromPlaceId() {
      axios.get("/place/" + this.dataIdPlace).then((response) => {
        this.dataCountry = response.data.country.name_en;
        if (response.data.province)
          this.dataRegion = response.data.region + "/" + response.data.province;
        else this.dataRegion = response.data.region;

        this.dataPlace = response.data.place_name;
        this.dataPostalCode = response.data.postal_code;
      });
    },
    async submitSearch() {
      var string = this.dataSearchPlaceName.split(" ");
      var url = null;
      if (this.dataIdCountry) {
        if (string.length > 1) {
          if (string[0] === "" || string[0] === null) {
            url =
              "/placeslist/" +
              this.dataIdCountry +
              "/ /" +
              string[1].trim();
          } else if (string[1] === null) {
          } else {
            url =
              "/placeslist/" +
              this.dataIdCountry +
              "/" +
              string[0].trim() +
              "/" +
              string[1].trim();
          }
        } else {
          url =
            "/placeslist/" + this.dataIdCountry + "/ /" + string[0].trim();
        }
        axios.get(url).then((response) => {
          if (response.data[0] === undefined) {
            //("SECOND LOOP")
            url =
              "/placeslist/" +
              this.dataIdCountry +
              "/" +
              string[0].trim() +
              "/";
            axios.get(url).then((response) => {
              this.data_options_places = [...response.data];
              this.dataIdPlace = response.data[0].id;
            });
          } else {
            this.data_options_places = [...response.data];
            this.dataIdPlace = response.data[0].id;
          }
        });
      } else {
        if (string.length > 1) {
          if (string[0] === "" || string[0] === null) {
            url = "/places/ /" + string[1].trim();
          } else if (string[1] === null) {
          } else {
            url = "/places/" + string[0].trim() + "/" + string[1].trim();
          }
        } else {
          url = "/places/ /" + string[0].trim();
        }
        axios.get(url).then((response) => {
          if (response.data[0] === undefined) {
            //("SECOND LOOP")
            url = "/places/" + string[0].trim() + "/";
            axios.get(url).then((response) => {
              this.data_options_places = [...response.data];
              this.dataIdPlace = response.data[0].id;
            });
          } else {
            this.data_options_places = [...response.data];
            this.dataIdPlace = response.data[0].id;
          }
        });
      }
      // Loading Category Address
      this.dataAddressCategory = 1;
    },
    async getOptionsCountries() {
      axios.get("/countrieslist").then((response) => {
        this.data_options_countries = [...response.data];
      });
    },
    async getOptionsPlaces() {
      axios.get("/placeslist/" + this.dataCountry).then((response) => {
        this.data_options_places = [...response.data];
      });
      /*Axios Get Places Where Country = selected */
    },
    initValues() {
      if (this.data.id) return;
      (this.dataAddressCategory = ""),
        (this.dataStreet = ""),
        (this.dataNumber = ""),
        (this.dataCountry = ""),
        (this.dataRegion = ""),
        (this.dataPlace = ""),
        (this.dataIdPlace = ""),
        (this.dataIdPerson = ""),
        (this.dataIsDefault = ""),
        (this.dataPostalCode = "");
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            id: this.dataId,
            street: this.dataStreet.replace(",", "-"),
            number: this.dataNumber,
            country: this.dataCountry,
            region: this.dataRegion,
            place: this.dataPlace,
            idperson: this.dataIdPerson,
            idaddress: this.dataId,
            isdefault: this.dataIsDefault,
            idplace: this.dataIdPlace,
            idaddresscategory: this.dataAddressCategory,
          };
          if (this.dataId !== null && this.dataId >= 0) {
            if (!modulePersonList.isRegistered) {
              this.$store.registerModule("peopleList", modulePersonList);
              modulePersonList.isRegistered = true;
            }
            if (this.$emit("closeSidebar")) {
              this.$store
                .dispatch("peopleList/updateAddress", obj)
                .then((response) => {
                  // Dire ce qui s'est reellement passe : une correction qui ne
                  // remonte pas jusqu'aux documents en cours est exactement ce
                  // que les utilisateurs signalaient comme « l'adresse saute ».
                  const data = (response && response.data) || {};
                  const repointed = (data.repointed || []).length;
                  const frozen = (data.frozen || []).length;
                  let text = "Address updated.";
                  if (data.mode === "copied") {
                    text += " " + repointed + " open document(s) updated";
                    if (frozen) text += "; " + frozen + " issued document(s) keep the previous address";
                    text += ".";
                  }
                  this.$vs.notify({ color: "success", title: "Address", text, time: 8000 });
                })
                .catch((err) => {
                  console.error(err);
                  const data = err.response && err.response.data;
                  this.$vs.notify({
                    color: "danger",
                    title: "Address not updated",
                    text: (data && (data.message || data.detail)) || err.message,
                    time: 10000,
                  });
                });
            }
          } else {
            // ADD NEW
            if (!modulePersonList.isRegistered) {
              this.$store.registerModule("peopleList", modulePersonList);
              modulePersonList.isRegistered = true;
            }

            if (this.$emit("closeSidebar")) {
              this.$store
                .dispatch("peopleList/createAddress", obj)
                .catch((err) => {
                  console.error(err);
                });
            }
          }
          this.initValues();
        }
      });
    },
  },
  created() {
    this.getOptionsCountries();
    this.getAddressCategory();
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
